const parameters = {
  PublicPortalUrl: 'PublicPortalURL',
  TapDisbursementRequestParentActiveSignHub:
    'TapDisbursementRequestParentActiveSignHub',
};

export default parameters;
